module.exports = ".dm-home-header-link {\r\n  text-decoration: none;\r\n  color: #67a6d3;\r\n  text-align: justify;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n}\r\n\r\n.dm-home-header-terms-of-use {\r\n  padding-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/feeds/feed-list/feed-list.component.css
// module id = ./src/app/main/feeds/feed-list/feed-list.component.css
// module chunks = main